import React from 'react'
import PropTypes from 'prop-types'
import {
    Drawer,
    DrawerBody,
    DrawerOverlay,
    DrawerContent
} from '@salesforce/retail-react-app/app/components/shared/ui'
import OrderSummary from '../../../components/order-summary'

const CheckoutDrawer = ({isOpen, onClose, basket}) => {
    return (
        <Drawer placement="right" onClose={onClose} isOpen={isOpen} size="xs">
            <DrawerOverlay />
            <DrawerContent bg="gray.125" minW="90vw">
                <DrawerBody>
                    <OrderSummary
                        onClose={onClose}
                        basket={basket}
                        showTaxEstimationForm={false}
                        showCartItems={true}
                    />
                </DrawerBody>
            </DrawerContent>
        </Drawer>
    )
}

CheckoutDrawer.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    basket: PropTypes.object.isRequired
}

export default CheckoutDrawer
